import { TEMP_NUMBER, getMapForPlacingRules, fillRulesToMap } from '../constants/nlpSettings';

/**
 * Function generates general intro message to tell ChatGPT what to do,
 * before data are prepared.
 */
const generateGeneralIntroMessage = (nlpConstants, nlpInstructions) => {
  // Name of the instruction in BaseRow
  const INSTRUCTION = 'Interface - General Before Data Instruction';

  // Get NLP constants
  const NLP_RESPONSE_TOKEN_LIMIT = nlpConstants
    ? parseInt(nlpConstants.NLP_RESPONSE_TOKEN_LIMIT.value, 10)
    : TEMP_NUMBER;

  // Get map for placing rules
  let mapForPlacingRules = getMapForPlacingRules(nlpInstructions, INSTRUCTION);

  // Group NLP rules and put them into map
  mapForPlacingRules = fillRulesToMap(nlpInstructions, INSTRUCTION, mapForPlacingRules);

  // Generate hotel intro message based on the map
  const intro = mapForPlacingRules.replace(
    /{{NLP_RESPONSE_TOKEN_LIMIT}}/g,
    NLP_RESPONSE_TOKEN_LIMIT,
  );

  return intro;
};

export default generateGeneralIntroMessage;
